import { createSlice } from "@reduxjs/toolkit";
import { getNotifications, getNotificationById, setNotificationAsRead } from "./thunk";

const initialState = {
  notifications: [],
  currentNotification: null,
  unreadCount: 0,
  loading: false,
  error: null,
  filters: {
    is_read: null,
    type: null,
  }
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentNotification: (state) => {
      state.currentNotification = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        is_read: null,
        type: null,
      };
    },
    updateUnreadCount: (state) => {
      state.unreadCount = state.notifications.filter(
        notification => !notification.is_read
      ).length;
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map(notification => ({
        ...notification,
        is_read: true,
        read_at: new Date().toISOString()
      }));
      state.unreadCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get All Notifications
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
        state.unreadCount = action.payload.filter(
          notification => !notification.is_read
        ).length;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Notification By ID
      .addCase(getNotificationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotificationById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentNotification = action.payload;
      })
      .addCase(getNotificationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Mark Notification as Read
      .addCase(setNotificationAsRead.pending, (state) => {
        state.error = null;
      })
      .addCase(setNotificationAsRead.fulfilled, (state, action) => {
        // Update the specific notification in the list
        const notificationIndex = state.notifications.findIndex(
          notification => notification.id === action.meta.arg
        );
        
        if (notificationIndex !== -1) {
          state.notifications[notificationIndex] = {
            ...state.notifications[notificationIndex],
            is_read: true,
            read_at: new Date().toISOString()
          };
        }

        // Update current notification if it's the same one
        if (state.currentNotification && state.currentNotification.id === action.meta.arg) {
          state.currentNotification = {
            ...state.currentNotification,
            is_read: true,
            read_at: new Date().toISOString()
          };
        }

        // Update unread count
        state.unreadCount = state.notifications.filter(
          notification => !notification.is_read
        ).length;
      })
      .addCase(setNotificationAsRead.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  clearError,
  clearCurrentNotification,
  setFilters,
  clearFilters,
  updateUnreadCount,
  markAllAsRead
} = notificationSlice.actions;

export default notificationSlice.reducer;